import { Box, Button } from "@mui/material";
import { useFormState } from "../../hooks/use-form-state";
import { textIsFilledValidator } from "../../utils/validators";
import { OutlinedInput } from "../../components/outlined-input";
import { useScreenAlert } from "../../hooks/use-screen-alert";
import { useRequestPasswordReset } from "../../hooks/use-request-password-reset";

const initialState = {
  username: "",
};

export const RequestPasswordReset = ({
  onRequestSuccess,
}: {
  onRequestSuccess: () => void;
}) => {
  const { setSuccess, setError } = useScreenAlert();
  const { loading, requestPasswordReset } = useRequestPasswordReset();

  const { state, handleChange, errors, hasError, handleSubmit } = useFormState({
    initialState,
    onSubmit: async (formData) => {
      const result = await requestPasswordReset(formData.username);
      if (!result) {
        setError("Failed to send password reset email. Please try again.");
        return;
      }

      setSuccess("A password reset link has been sent to your email.");
      onRequestSuccess();
    },
    validate: (formData) => {
      const errors: Record<string, string | undefined> = {};
      errors.username = textIsFilledValidator(formData.username);
      return errors;
    },
  });

  return (
    <Box>
      <OutlinedInput
        value={state.username}
        onChange={handleChange("username")}
        label="Username or Email"
        name="username"
        disabled={loading}
        error={errors.username}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={hasError || loading}
        sx={{ mt: 2 }}
      >
        {loading ? "Requesting Reset..." : "Request Password Reset"}
      </Button>
    </Box>
  );
};
